import { render, staticRenderFns } from "./SuspendButton.vue?vue&type=template&id=4f5d1b02&scoped=true&"
import script from "./SuspendButton.vue?vue&type=script&lang=js&"
export * from "./SuspendButton.vue?vue&type=script&lang=js&"
import style0 from "./SuspendButton.vue?vue&type=style&index=0&id=4f5d1b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d1b02",
  null
  
)

export default component.exports